<template>
    <div class="padding-content mb-4">
        <div class="h2 mb-1"> <span>{{ $t('general.abono', {abono: teatro.texto_abono}) }} {{ index }}</span></div>
        <div class="h5 mb-4 regular" v-if="abono.tipo_abono">{{ abono.tipo_abono.descripcion}}</div>
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :label="$t('formularios.nombre')" 
                    :name="'nombre' + index" 
                    rules="required" 
                    v-model="abono.nombre"
                />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :label="$t('formularios.apellidos')" 
                    :name="'apellidos' + index" 
                    rules="required" 
                    v-model="abono.apellidos" 
                />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <label>{{ $t('formularios.genero') }}</label>
                    <ValidationProvider :name="'genero' + index" rules="required" v-slot="{ errors }">
                        <multiselect
                            :id="'genero' + index"
                            v-model="abono.genero"
                            :placeholder="$t('formularios.genero')"
                            label="name"
                            track-by="id"
                            :options="generos"
                            class="custom-multiselect"
                            @select="(option, id) => abono.genero_id = id"
                        />
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs error-message"><b>{{ errors[0] }}</b></span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :infoText="info_text"
                    :label="$t('formularios.dni')" 
                    :name="'dni' + index" 
                    rules="required" 
                    v-model="abono.dni" 
                />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <label for="fecha_nacimiento">{{ $t('formularios.nacimiento') }}</label>
                    <ValidationProvider :name="'fecha_nacimiento' + index" rules="required" v-slot="{ errors }">
                        <input type="date" v-model="abono.fecha_nacimiento" id="fecha_nacimiento" name="fecha_nacimiento" min="1900-01-01" max="2999-12-31"/>
                        <span v-if="errors[0]" class="invalid-feedback mb-4 text-xs error-message"><b>{{ errors[0] }}</b></span>
                    </ValidationProvider>
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :label="$t('formularios.email')" 
                    :name="'email' + index" 
                    rules="required|email" 
                    v-model="abono.email" 
                />
            </div>
            <div class="col-12 col-md-6 col-lg-4 mb-2">
                <div class="form-group">
                    <label>{{ $t('formularios.telefono') }}</label>
                    <PhoneInput
                        :key="error_telefono"
                        :name="'telefono' + index" 
                        :phone="abono.telefono ?? null"
                        :required="true"
                        :error_telefono="error_telefono"
                        @setNumber="(number) => abono.telefono = number"
                        @validNumber="(valid) => abono.telefono_valido = valid"
                    />
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Paises 
                        :pais="pais"
                        :errors="errors" 
                        @rellenarPais="rellenarPais" 
                        v-on:selected="opt => { pais = opt; abono.pais = opt.nombre; }"
                    />
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Provincias
                        :errors="errors" 
                        :pais="pais.id" 
                        :provincia="provincia" 
                        v-on:selected="opt => { provincia = opt; abono.provincia = opt.nombre; }"
                    />
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <div class="form-group">
                    <Locations 
                        :provincia="provincia" 
                        :errors="errors" 
                        v-on:selected="opt => { abono.localidad = opt.nombre; }"
                    />
                </div>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :label="$t('formularios.domicilio')" 
                    :name="'domicilio' + index" 
                    rules="required" 
                    v-model="abono.domicilio" 
                />
            </div>
            <div class="col-12 col-md-6 col-lg-4">
                <FormInput 
                    :label="$t('formularios.cp')" 
                    :name="'cp' + index" 
                    rules="required" 
                    v-model="abono.cp" 
                />
            </div>
            <b-col cols="12">
                <div class="form-group">
                    <div class="d-flex">
                        <label class="mr-2" for="descuento">{{ $t('formularios.tipo_abono', {abono: teatro.texto_abono}) }}</label>
                    </div>
                    <ValidationProvider :name="'descuento' + index" rules="required" v-slot="{ errors }">
                        <multiselect
                            :class="(errors[0] ? 'is-invalid' : '')"
                            v-model="abono.descuento"
                            :placeholder="$t('formularios.tipo_abono', {abono: teatro.texto_abono})"
                            track-by="id"
                            :options="descuentos"
                            :allowEmpty="false"
                            :preselectFirst="true"
                            :custom-label="({ descripcion, precio }) => descripcion + ' - ' + $options.filters.formatear_precio(precio)"
                        />                       
                        <span 
                            v-if="errors[0]" 
                            class="invalid-feedback mb-4 text-xs" 
                            style="font-size: 11px; width: 99.72%; display: block; background-color: #DC3545; color: white; padding: 6px;"
                        >
                            <b>{{ $t('formularios.seleccione_tipo_abono') }}</b>
                        </span>
                    </ValidationProvider>
                </div>
            </b-col>
            <div class="col-12 form-group mt-3" v-if="teatro.url_whatsapp_abonos">
                <div class="checkbox-container">
                    <input type="checkbox" :name="'envio-whatsapp-' + index" :id="'envio-whatsapp-' + index" v-model="abono.envio_whatsapp"/>
                    <label :for="'envio-whatsapp-' + index">{{ $t('formularios.acepto_envio_whatsapp', { termino: 'abonos' }) }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Provincias from "@/components/common/forms/Provincias";
    import Locations from "@/components/common/forms/Locations";
    import Paises from "@/components/common/forms/Paises";
    import PhoneInput from '@/components/common/PhoneInput.vue';

    export default {
        props: {
            index: {
                type: Number,
                required: true
            },
            abono: {
                type: Object,
                required: true
            },
            generos: {
                type: Array,
                required: true
            },
            descuentos: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
                info_text: "A modo informativo queremos aconsejarle que sea cuál sea el formato en el que introduzca el DNI lo recuerde para posibles futuros procesos",
                error: null,
                error_telefono: null,
                errors: [],
                pais: { id: 0 },
                provincia: null,
            }
        },
        computed: {
            teatro(){
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            // Initialize pais from abonado data (string name like "Andorra")
            if (this.abono.pais) {
                this.pais = { nombre: this.abono.pais };
            }
            // Initialize provincia from abonado data
            if (this.abono.provincia) {
                this.provincia = this.abono.provincia;
            }
        },
        methods: {
            rellenarPais(pais) {
                if (pais && pais.nombre) {
                    this.pais = pais;
                    this.abono.pais = pais.nombre;
                }
            }
        },
        components: {
            Provincias, Locations, Paises, PhoneInput
        }
    }
</script>